import { Utils } from "src/modules/utils/shared/utils";
import { Type } from "class-transformer";
import { EnaioScriptType } from "./EnaioScriptType";
import { EnaioWorkflowDefinition } from "./EnaioWorkflowDefinition";
import { EnaioWorkflowEventType } from "./EnaioWorkflowEventType";

export class EnaioWorkflowEventDefinition {
    @Type(() => EnaioWorkflowDefinition)
    parent: EnaioWorkflowDefinition;
    id = "";
    appId = "";
    clientTypeId = "";
    type: EnaioWorkflowEventType;
    param = "";
    code = "";
    scriptId = "";
    language = 0;
    scriptType: EnaioScriptType;

    getUniqueId(): string {
        return this.appId + "|" + this.clientTypeId + "|" + this.id + "|" + this.param
    }

    getSpeakingName(): string {
        return (Utils.isNoe(this.param) ? "" : this.param + ":") + Utils.upperFirst(EnaioWorkflowEventType.getName(this.type));
    }


}
